// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b76afb675cb4759e3ada","883":"a6ec32158524eb4896dc"}[chunkId] + ".js";
};